import { forwardRef } from "react";

import { formatAriaInvalid } from "./style.utils";
import { textareaVariants, type TextareaVariants } from "./textarea.styles";

export type TextareaRef = React.ComponentRef<"textarea">;

export interface TextareaProps
  extends
    Omit<React.ComponentPropsWithoutRef<"textarea">, "size">,
    Omit<TextareaVariants, "invalid"> {
  name: string;
}

const Textarea = forwardRef<TextareaRef, TextareaProps>(
  (
    { "aria-invalid": ariaInvalid, className, disabled, size, ...props },
    ref,
  ) => {
    return (
      <textarea
        {...props}
        disabled={disabled}
        aria-invalid={ariaInvalid}
        className={textareaVariants({
          className,
          disabled,
          invalid: formatAriaInvalid(ariaInvalid),
          size,
        })}
        ref={ref}
      />
    );
  },
);

Textarea.displayName = "Textarea";

export { Textarea };
